import React, { Fragment } from 'react'

import MultiRowsActions from './table/MultiRowsActions'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import MinicrudsLoader from './_load/MinicrudsLoader'
import MiniCrudsTable from './table/MinicrudsTable'

const PageContent = () => {
  return (
    <>
      <MultiSelectHandler>
        <MinicrudsLoader uncontrolledChildren={<MultiRowsActions />}>
          <MiniCrudsTable />
        </MinicrudsLoader>
      </MultiSelectHandler>
    </>
  )
}

export default PageContent
